module.exports = __webpack_public_path__ + "img/Group 17.26c23a5.svg";